<div class="lm-container" *ngIf="true">
  <mat-card class="mcd-latest-modification" style="min-height: 300px;">
    <div class="latest-modification-header">
      <span class="latest-modification-title">Recent Updates</span>
      <!-- <mat-icon class="latest-modification-info-icon" title="Standards and equipment updated, added or made obsolete recently">info_outline</mat-icon> -->
      <!-- <a class="latest-modification-view-all" routerLink="/notification-list">View all <i class="material-icons">arrow_forward</i></a> -->
    </div>
    <div class="latest-modification-tabs-row">
      <div class="range-filter-wrap">
        <div class="range-segmented" *ngIf="!isCustomApplied">
          <button
            type="button"
            class="range-segment"
            [class.is-active]="selectedRange === '5d'"
            (click)="selectRange('5d')"
          >
            5 Days
          </button>
          <button
            type="button"
            class="range-segment"
            [class.is-active]="selectedRange === '15d'"
            (click)="selectRange('15d')"
          >
            15 Days
          </button>
          <button
            type="button"
            class="range-segment"
            [class.is-active]="selectedRange === '30d'"
            (click)="selectRange('30d')"
          >
            30 Days
          </button>
          <button
            type="button"
            class="range-segment"
            (click)="openCustomPopover()"
          >
            <i class="material-icons">calendar_today</i> Custom
          </button>
        </div>

        <div class="range-applied-pill" *ngIf="isCustomApplied">
          <span class="range-applied-text" (click)="openCustomPopover()">
            {{ customRangeLabel }}
            <span class="range-applied-divider">|</span>
            {{ customDaysCount }} Days
          </span>
          <button type="button" class="range-reset-btn" (click)="resetRange()">
            <img src="/assets/images/RESET ICON.svg" alt="" /> Reset
          </button>
        </div>

        <div class="range-popover-backdrop" *ngIf="showCustomPopover" (click)="cancelCustomPopover()"></div>
        <div class="range-popover" *ngIf="showCustomPopover">
          <div class="range-popover-title">Custom range</div>

          <label class="range-popover-label">From</label>
          <div class="newForm">
            <mat-form-field class="range-popover-field">
              <input matInput [matDatepicker]="rangePickerFrom" [(ngModel)]="draftStartDate" />
              <mat-datepicker-toggle matSuffix [for]="rangePickerFrom">
                <img matDatepickerToggleIcon src="/assets/images/date-calender.svg" alt="Calendar" />
              </mat-datepicker-toggle>
              <mat-datepicker #rangePickerFrom></mat-datepicker>
            </mat-form-field>
          </div>

          <label class="range-popover-label">To</label>
          <div class="newForm">
            <mat-form-field class="range-popover-field">
              <input matInput [matDatepicker]="rangePickerTo" [(ngModel)]="draftEndDate" />
              <mat-datepicker-toggle matSuffix [for]="rangePickerTo">
                <img matDatepickerToggleIcon src="/assets/images/date-calender.svg" alt="Calendar" />
              </mat-datepicker-toggle>
              <mat-datepicker #rangePickerTo></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="range-popover-actions">
            <button type="button" class="range-popover-cancel" (click)="cancelCustomPopover()">Cancel</button>
            <button type="button" class="range-popover-apply" (click)="applyCustomPopover()">Apply</button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="loading" style="height: 400px; display: flex; justify-content: center; align-items: center;">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <div class="mcd-latest-modification-list" *ngIf="!loading">
      <div
        class="mcd-latest-modification-item"
        *ngFor="let record of latestModification"
        routerLink="{{ record.redirectUrl }}"
      >
        <span class="mcd-latest-modification-icon">
          <img [src]="getRecordIcon(record)" alt="" />
        </span>
        <div class="mcd-latest-modification-body">
          <div class="mcd-latest-modification-title-row">
            <div class="mcd-latest-modification-title">
              {{ record.title }}
            </div>
            <span class="mcd-latest-modification-date">{{ record.date | date: "d MMM, y" }}</span>
          </div>
          <div class="mcd-latest-modification-description" [ngClass]="record.badgeClass">
            <strong>{{ record.badgeLabel }}:</strong> {{ record.description }}
          </div>
        </div>
      </div>
      <div *ngIf="latestModification.length === 0" class="latest-modification-empty">
        No updates in this period.
      </div>
    </div>
  </mat-card>
  <!-- <app-email-subscribe-popup ></app-email-subscribe-popup> -->
</div>
<!-- <app-mcd-loader *ngIf="loading"></app-mcd-loader> -->
